module.exports = __webpack_public_path__ + "img/paperclip-2.82a2f238.png";